import { render } from "./AdminDriverListLive.vue?vue&type=template&id=21fe5696&scoped=true&ts=true&lang=true"
import script from "./AdminDriverListLive.vue?vue&type=script&lang=ts"
export * from "./AdminDriverListLive.vue?vue&type=script&lang=ts"

import "./AdminDriverListLive.vue?vue&type=style&index=0&id=21fe5696&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fe5696"]])

export default __exports__